import { SVGProps } from "react"

interface SearchIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

const SearchIcon = ({ size = 12, ...props }: SearchIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...props}
    >
      <g
        stroke="#B7B9BC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        clipPath="url(#a)"
      >
        <path d="M1.5 5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0ZM10.5 10.5l-3-3" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  )

  export default SearchIcon